"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ palette }) => ({
    menuRoot: {
        paddingLeft: 5,
        paddingRight: 5,
    },
    txPrefMenuWhite: {
        color: palette.primary.contrastText,
        width: 'inherit',
    },
    txPrefMenuBlack: {
        color: palette.text.secondary,
        width: 'inherit',
    },
    menuHolder: {
        marginTop: -5,
        display: 'inline',
        height: 'inherit',
        width: 24,
    },
    menuSubHead: {
        paddingLeft: 7,
        paddingRight: 5,
        paddingBottom: 5,
        color: palette.text.tertiary,
    },
    listIcon: {
        marginLeft: 0,
        marginRight: 0,
        minWidth: 0,
    },
    listText: {
        paddingLeft: 10,
    },
    popOver: {
        padding: 20,
    },
    iconFiller: {
        width: 24,
    },
    colorBar: {
        width: 10,
        height: 10,
        marginLeft: 5,
    },
    parentList: {
        paddingBottom: 0,
        '&:focus': {
            outline: 'none',
        },
    },
});
exports.styles = styles;
